import { defineComponent as _defineComponent } from 'vue'
import { queries } from "@/apollo";
import { CompanyReport } from "@/CodegenTypes";
import { first } from "lodash";
import { formatCount } from "@/helpers/formatCount";
import { formatDollar } from "@/helpers/formatDollar";
import { negateNumber } from "@/helpers/negateNumber";
import { useRoute } from "vue-router/composables";
import { computed } from "vue";
import { useQuery } from "@vue/apollo-composable";
import CompanyPlTable from "@/components/modules/report/CompanyPlTable.vue";
import { FEATURE_TOGGLES } from "@/config";
import { useTranslation } from "@/store/translation";



export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyStakeReportLegacy',
  setup(__props) {

const { $t } = useTranslation();
const route = useRoute()
const selectedStartReleaseDate = computed(() => {
  const query = route.query.startReleaseDate;
  return Array.isArray(query) ? first(query) : query;
})


const selectedEndReleaseDate = computed(() => {
  const query = route.query.endReleaseDate;
  return Array.isArray(query) ? first(query) : query;

})

const selectedDateRangeReady = computed(() =>
  !!selectedStartReleaseDate.value && !!selectedEndReleaseDate.value
);

const selectedDateRangeVariables = computed(() => ({
  releaseDateStart: selectedStartReleaseDate.value,
  releaseDateEnd: selectedEndReleaseDate.value,
}));

const companyReportQuery = FEATURE_TOGGLES.useV1Legacy
  ? queries.companyReportLegacy
  : queries.companyReport;

const { result, loading } = useQuery<{ companyReport: CompanyReport }>(
  companyReportQuery,
  selectedDateRangeVariables,
  {
    enabled: selectedDateRangeReady,
    fetchPolicy: "cache-and-network",
  },
);



return { __sfc: true,$t, route, selectedStartReleaseDate, selectedEndReleaseDate, selectedDateRangeReady, selectedDateRangeVariables, companyReportQuery, result, loading, formatCount, formatDollar, negateNumber, CompanyPlTable }
}

})